import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {Subject, takeUntil} from "rxjs";
import {EmployeeService} from "../../../services/employees/employe.service";
import {MessageService} from "primeng/api";
import {DeleteEmployeeModel} from "../../../models/employees/delete-employee.model";

@Component({
  selector: 'app-delete-employee',
  templateUrl: './delete-employee.component.html',
  styleUrls: ['./delete-employee.component.scss']
})
export class DeleteEmployeeComponent implements OnInit {

  //#region Fields
  public employeeId: string;
  public spinner: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  //#endregion

  //#region Constructor
  constructor(private config: DynamicDialogConfig,
              private ref: DynamicDialogRef,
              private employeeService: EmployeeService,
              private messageService: MessageService) {
    if (this.config.data != undefined && this.config.data.id) {
      this.employeeId = this.config.data.id;
    }
  }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  deleteEmployee(employeeId: string) {
    let deleteEmployeeModel = new DeleteEmployeeModel();
    deleteEmployeeModel.employeeId = employeeId;

    this.spinner = true;
    this.employeeService.deleteEmployee(deleteEmployeeModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.ref.close(true)
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
